import React from 'react';
import AnchorLink from 'components/AnchorLink';

import { urls } from 'constants/urls';
import { Banner } from './Banner';
import UrgencyBanner from './UrgencyBanner';
import { useUrgencyBanner } from '../useUrgencyBanner';

export default function UrgencyBannerSelector() {
  const [type, payload] = useUrgencyBanner();

  switch (type) {
    case null:
      return null;
    case 'payment': {
      return (
        <Banner type="danger">
          Payment failed. To pay and receive your order,{' '}
          <AnchorLink to={urls.myOrdersPage}>go to my orders</AnchorLink>
        </Banner>
      );
    }
    default:
      return <UrgencyBanner {...payload} type={type} />;
  }
}
